import React, { Component } from "react";
import ThirdPageComponents from "views/Pma/PmaEditor/ThirdPageComponents";

class YETwoSecondRight extends Component {
  render() {
    const {
      currentArea,
      agentData,
      printVersion,
      fromEditor,
      version,
      hoData,
      mlsAreas,
      demoAccountHOName,
      quarterlyAreaTable,
      quarterlyCityTable,
      propertyData,
      MQCityDetails,
      isDemo,
      missionStatement,
      coverPageDetails,
      miniTableDetailsDTO,
      showAllEditButtons,
      lastPMAPrintDate,
    } = this.props;

    return (
      <ThirdPageComponents
        printVersion={printVersion}
        fromEditor={fromEditor}
        missionStatement={missionStatement}
        agentData={agentData}
        currentArea={currentArea}
        hoData={hoData}
        mlsAreas={mlsAreas}
        version={version}
        demoAccountHOName={demoAccountHOName}
        isDemo={isDemo}
        quarterlyAreaTable={quarterlyAreaTable}
        quarterlyCityTable={quarterlyCityTable}
        propertyData={propertyData}
        MQCityDetails={MQCityDetails}
        coverPageDetails={coverPageDetails}
        miniTableDetailsDTO={miniTableDetailsDTO}
        showAllEditButtons={showAllEditButtons}
        lastPMAPrintDate={lastPMAPrintDate}
      />
    );
  }
}

export default YETwoSecondRight;
